 // resize events
 let current;

 const btnPrimaryPos = document.querySelector('.js-btn-primary-pos');
 const navMainPos = document.querySelector('.js-nav-main-pos');

 const sliderControlsPos = document.querySelector('.js-slider-controls-pos');
 const siteHeadlineLeftPos = document.querySelector('.js-site-headline-left-pos');
 const sliderPartnersPos = document.querySelector('.js-slider-partners-pos');

 // positioning elements
 window.addEventListener('resize', function () {
   if (current !== 'xs' && mq[0].matches) {

     if (btnPrimaryPos) {
       navMainPos.append(btnPrimaryPos);
     }

     if (sliderControlsPos) {
       sliderPartnersPos.parentNode.insertBefore(sliderControlsPos, sliderPartnersPos.nextSibling);
     }

     current = 'xs';

   } else if (current !== 'sm' && mq[1].matches) {

     if (btnPrimaryPos) {
       navMainPos.append(btnPrimaryPos);
     }

     if (sliderControlsPos) {
       sliderPartnersPos.parentNode.insertBefore(sliderControlsPos, sliderPartnersPos.nextSibling);
     }

     current = 'sm';

   } else if (current !== 'md' && mq[2].matches) {

     if (btnPrimaryPos) {
       navMainPos.parentNode.insertBefore(btnPrimaryPos, navMainPos.nextSibling);
     }

     if (sliderControlsPos) {
       sliderPartnersPos.parentNode.insertBefore(sliderControlsPos, sliderPartnersPos.nextSibling);
     }

     current = 'md';


   } else if (current !== 'xl' && mq[3].matches) {

     if (btnPrimaryPos) {
       navMainPos.parentNode.insertBefore(btnPrimaryPos, navMainPos.nextSibling);
     }

     if (sliderControlsPos) {
       siteHeadlineLeftPos.parentNode.insertBefore(sliderControlsPos, siteHeadlineLeftPos.nextSibling);
     }

     current = 'xl';

   }
 });

 window.dispatchEvent(new Event('resize'));